'use es6';

import makeAsyncLoader from './makeAsyncLoader';
const AsyncDetailPanel = makeAsyncLoader(() => import( /* webpackChunkName: "detail-panel" */'../detailsPanel').then(module => module.default).catch(err => {
  throw err;
}));
export default AsyncDetailPanel;